import { Suspense, useContext, useEffect } from "react";
import { Oval } from "react-loader-spinner";
import { Route, Routes } from "react-router-dom";
import routes from "routes";

import { DashboardContext } from "./DashboardContext";
import DashboardFooter from "./DashboardFooter";
import DashboardHeader from "./DashboardHeader";
import DashboardSidebar from "./DashboardSidebar";

const DefaultDashboard = ({ children }) => {
  const context = useContext(DashboardContext);
  const loading = () => (
    <div className=" flex  flex-1 w-full h-full justify-center items-center ">
      <Oval height={100} width={100} color="royalblue" secondaryColor="white" />
    </div>
  );
  const { headerToggle } = context;
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div
      id="mainContent"
      className={`relative text-slate-300 min-h-screen h-screen w-full  flex   bg-main
      after:absolute after:w-full after:h-full after:bg-black/60 after:lg:invisible after:backdrop-blur-sm after:opacity-100 after:z-[10]  ${
        headerToggle &&
        "after:invisible after:transition-all after:duration-300  after:ease-in-out after:opacity-0"
      }`}
    >
      <DashboardSidebar />

      <div className="flex flex-col w-full">
        <DashboardHeader />
        <div
          id="containerSection"
          className="flex flex-col flex-1 scroll-smooth  w-full bg-main overflow-y-auto overflow-x-hidden "
        >
          <div className=" relative px-5 py-5 md:p-8   flex-1">
            <Suspense fallback={loading()}>
              <Routes>
                {routes.map((route, idx) => {
                  return route.element ? (
                    <Route
                      key={idx}
                      path={route.path}
                      element={route.element}
                    />
                  ) : null;
                })}
              </Routes>
            </Suspense>
          </div>
          <DashboardFooter />
        </div>
      </div>
    </div>
  );
};

export default DefaultDashboard;
